import React, { useState, useEffect } from 'react';
import API from '../../pages/Api';
import { toast } from 'react-toastify';
import { FaPaperPlane, FaPaperclip, FaTimes } from 'react-icons/fa';

const MudrabhyasHindi= () => {
    const [activeTab, setActiveTab] = useState('Welcome');
    const [mediaData, setMediaData] = useState([]);
    const [showVideoModal, setShowVideoModal] = useState(false);
    const [videoUrl, setVideoUrl] = useState(null);
    const [videoData, setVideoData] = useState([]);
    const [chatHistory, setChatHistory] = useState([]);
    const [newMessage, setNewMessage] = useState("");
    const [selectedQueryId, setSelectedQueryId] = useState(null);
    const [file, setFile] = useState(null);
    const [filePreview, setFilePreview] = useState(null);

    const [isAskingNew, setIsAskingNew] = useState(false);
    const [newQueryText, setNewQueryText] = useState("");
    const [feedbackForm, setFeedbackForm] = useState({ 
        feedbacktitle: '', 
        feedbackdesc: '', 
        givenby: '', 
        profession: '' 
    });

    useEffect(() => {
       
        const userName = localStorage.getItem('name') || 'Guest'; 
        setFeedbackForm(prev => ({ ...prev, givenby: userName }));
    }, [])

    const [apptForm, setApptForm] = useState({
        age: '',
        occupation: '',
        problem: ''
    });


    const tabs = ['Welcome', 'Disclaimer', 'Videos', 'Study Material', 'Book Appointment', 'FeedBack','Query'];
    const pageContent = {
        welcome: [
            { title: "MUDRAS - The divine Pharmacy!", text: "This course is designed to take you on a transformative journey through the ancient science of Mudras." },
            { title: "Course Modules", text: "The course consists of eight essential video modules:", points: ["Mudra Importance", "Mudra Basics", "Tatwa Mudras", "Pranic Mudras", "Therapeutic Mudras (Part 1, 2, & 3)", "Summary & Review"] },
            { title: "Your Daily Practice", text: "After completing all videos, prepare a set of Mudras tailored for your daily practice. Study the do's and don'ts thoroughly to ensure maximum benefit." },
            { title: "Certification Project", text: "Those seeking certification are required to: Prescribe a set of Mudras to five people, follow up for fifteen days, record the improvements, and email the report for final approval." }
        ],
        disclaimer: [
            "The training is intended for informational and educational purposes, it is not intended to substitute for professional medical advice, diagnosis, and/or treatment.",

            "Please consult your medical professional before making changes to your diet, exercise routine, medical regimen, lifestyle, and/or mental health care."
        ]
    };
    const handleSubmitFeedback = async () => {
        const userId = localStorage.getItem('userid');
        
        
        try {
            await API.post('create-feedback/', {
                userid: parseInt(userId),
                courseid: 32,
                feedbacktitle: feedbackForm.feedbacktitle,
                feedbackdesc: feedbackForm.feedbackdesc,
                givenby: feedbackForm.givenby, 
                profession: feedbackForm.profession
            });
            toast.success("Feedback submitted successfully!");
           
            const userName = localStorage.getItem('name') || '';
            setFeedbackForm({ feedbacktitle: '', feedbackdesc: '', givenby: userName, profession: '' });
        } catch (err) {
            toast.error("Error: " + (err.response?.data?.error || "Failed to submit"));
        }
    };
    const handleBookAppointment = async () => {
    
    if (!apptForm.age || !apptForm.occupation || !apptForm.problem) {
        toast.warn("Please fill in all information!");
        return;
    }

    const userId = localStorage.getItem('userid');
    
        if (!userId) {
            toast.error("The login session has expired, please login again.");
            return;
        }

        try {
           
            const response = await API.post('create-appointment/', {
                userid: parseInt(userId),
                courseid: 32, 
                age: apptForm.age,
                occupation: apptForm.occupation,
                problem: apptForm.problem
            });

            
            toast.success("Your appointment has been successfully booked!");
            
            
            setApptForm({ age: '', occupation: '', problem: '' });

        } catch (err) {
            console.error("Booking Error:", err);
           
            const errorMsg = err.response?.data?.error || "Something went wrong, try again.";
            toast.error("error: " + errorMsg);
        }
    };
    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            setFilePreview(URL.createObjectURL(selectedFile));
        }
    };
    const loadChatHistory = async (queryId) => {
        try {
            const res = await API.get(`chat/${queryId}/`);
            setChatHistory(res.data.userChats || []);
        } catch (err) { console.error("Chat Error:", err); }
    };
    const handleCreateQuery = async () => {
        if (!newQueryText.trim()) return;
        
        
        const loggedInUser = localStorage.getItem('userId'); 
        
        if (!loggedInUser) {
            toast.warn("Please login first to ask a query.");
            return;
        }

        try {
            const res = await API.post('create-query/', {
                userid: parseInt(loggedInUser), 
                courseid: 32, 
                userquery: newQueryText,
                usertype: 1
            });
            
            setSelectedQueryId(res.data.queryId);
            setIsAskingNew(false);
            setNewQueryText("");
            loadChatHistory(res.data.queryId);
        } catch (err) { 
            console.error("Create Query Error:", err); 
            toast.error("Error creating query: " + err.response?.data?.error || "Unknown error");
        }
    };
    const sendMessage = async () => {
        if (!newMessage.trim() && !file) return;
        const formData = new FormData();
        formData.append('queryId', selectedQueryId); 
        formData.append('message', newMessage); 
        if (file) formData.append('file_attachment', file);

        try {
            await API.post(`chat/user-send/${selectedQueryId}/`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
            setNewMessage('');
            setFile(null);
            setFilePreview(null);
            loadChatHistory(selectedQueryId);
        } catch (error) {
            console.error("Error:", error);
            toast.error("Error sending message.");
        }
    };


    const getYouTubeId = (url) => {
        if (!url) return null;

        const match = url.match(
            /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|v\/|shorts\/))([\w-]{11})/
        );

        return match ? match[1] : null;
    };
    const fetchMentorData = async (tab) => {
        try {

            if (
                tab === 'Videos' ||
                tab === 'Study Material'
            ) {

                const res = await API.get(
                    'getAllVideoAndStudyList/',
                    {
                        params: {
                            courseName: 'MUDRABHYAS HINDI'
                        }
                    }
                );

                const filtered = res.data.filter(
                    (item) =>
                        item.materialName ===
                        (tab === 'Videos'
                            ? 'Video'
                            : 'Study Material')
                );

                setMediaData(filtered);

            } else if (tab === 'Query') {

                const qRes = await API.get(
                    'query-list/'
                );

                if (qRes.data.length > 0) {
                    setSelectedQueryId(
                        qRes.data[0].queryId
                    );

                    loadChatHistory(
                        qRes.data[0].queryId
                    );

                } else {
                    setIsAskingNew(true);
                }
            }

        } catch (err) {
            console.error(err);
        }
    };
    useEffect(() => { fetchMentorData(activeTab); }, [activeTab]);

    return (
        <div className="min-h-screen
        bg-gray-50
        p-2
        md:p-8
        w-full
        max-w-full
        overflow-x-hidden">
            <div className="max-w-6xl mx-auto mb-4 md:mb-8 bg-white p-3 md:p-6 rounded-xl border-2 border-blue-900 shadow-sm overflow-hidden">
                <h2 className="text-2xl md:text-3xl font-normal text-blue-900 mb-4 md:mb-6 text-center uppercase break-words">Mudrabhyas Hindi</h2>
                <div className="flex flex-wrap gap-1 md:gap-2 justify-center">
                    {tabs.map(tab => (
                        <button key={tab} onClick={() => setActiveTab(tab)} className={`px-2
                            md:px-6
                            py-2
                            text-[10px]
                            md:text-sm
                            rounded-md
                            font-semibold
                            border
                            transition-all
                            whitespace-nowrap
                            ${
                                activeTab === tab
                                    ? 'bg-blue-900 text-white'
                                    : 'bg-white text-blue-900'
                            }`}>
                            {tab}
                        </button>
                    ))}
                </div>
            </div>

            <div className="">
                {activeTab === 'Welcome' && (
                    <div className="space-y-4">
                        {pageContent.welcome.map((item, i) => (
                            <div
                                key={i}
                                className="
                                    bg-white
                                    border
                                    border-gray-200
                                    rounded-xl
                                    p-4
                                    shadow-sm
                                    
                                "
                            >
                                <h4 className="font-bold text-blue-900 text-lg md:text-xl break-words">
                                    {item.title}
                                </h4>

                                <p className="text-sm md:text-base leading-relaxed break-words text-gray-700">
                                    {item.text}
                                </p>
                            </div>
                        ))}
                    </div>
                )}

                {activeTab === 'Disclaimer' && (
                    <div className="space-y-4">
                        {pageContent.disclaimer.map((para, i) => (
                            <p
                                key={i}
                                className="p-3 bg-gray-50 rounded border-l-4 border-blue-900"
                            >
                                {para}
                            </p>
                        ))}
                    </div>
                )}
                
                
                {/* Videos Section with Creative Preview */}
                {activeTab === 'Videos' && (
                    <div className="space-y-4 max-h-[600px] overflow-y-auto pr-2">

                        {mediaData.map((v) =>
                            v.attachmentData?.map((att, idx) => {

                                // const videoSrc = att.link
                                //     ? att.link
                                //     : `${process.env.REACT_APP_MEDIA_URL || 'https://tgsh.geometricsoft.com'}/${att.attachmentname}`;

                                const videoSrc =
                                    att.link ||
                                    (att.attachmentname?.startsWith('/media')
                                        ? `${process.env.REACT_APP_BACKEND_URL || 'http://103.172.92.148:8005'}${att.attachmentname}`
                                        : `${process.env.REACT_APP_MEDIA_URL || 'https://tgsh.geometricsoft.com'}/media/${att.attachmentname}`);

                                const rawLink = att.link || '';
                                    const isYoutube =
                                        rawLink.includes('youtube.com') ||
                                        rawLink.includes('youtu.be');

                                return (
                                    <div
                                        key={idx}
                                        className=" w-full
                                        flex
                                        flex-col
                                        md:flex-row
                                        items-start
                                        md:items-center
                                        gap-4
                                        border
                                        rounded-2xl
                                        p-4
                                        bg-white
                                        shadow-sm
                                        hover:shadow-md
                                        transition-all"
                                    >

                                        {/* Left Preview */}
                                        <div className="w-full md:w-56 h-48 md:h-32 bg-gray-200 rounded-xl overflow-hidden shrink-0">

                                            {(() => {
                                                const videoId =
                                                    att.link?.match(/(?:youtu\.be\/|youtube\.com\/.*v=)([^&]+)/)?.[1];

                                                if (videoId) {
                                                    return (
                                                        <img
                                                            className="w-full h-full object-cover"
                                                            src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
                                                            alt="YouTube Thumbnail"
                                                        />
                                                    );
                                                }

                                                if (videoSrc) {
                                                    return (
                                                        <video
                                                            className="w-full h-full object-cover"
                                                            muted
                                                            preload="metadata"
                                                        >
                                                            <source src={videoSrc} type="video/mp4" />
                                                        </video>
                                                    );
                                                }

                                                return (
                                                    <div className="w-full h-full flex items-center justify-center text-gray-500">
                                                        No Preview
                                                    </div>
                                                );
                                            })()}

                                        </div>

                                        {/* Right Content */}
                                        <div className="flex-1">

                                            <h3 className="text-lg md:text-2xl font-bold text-gray-800 mb-2 break-words">
                                                {att.description || "Video Module"}
                                            </h3>

                                            <p className="text-sm text-gray-500 mb-4">
                                                Watch this learning module
                                            </p>

                                            <button
                                                onClick={() => {
                                                    console.log("RAW LINK:", att.link);
                                                    console.log("VIDEO SRC:", videoSrc);
                                                    const videoId = getYouTubeId(att.link);
                                                    console.log("EXTRACTED VIDEO ID:", videoId)
                                                    if (videoId) {
                                                            const embedUrl = `https://www.youtube.com/embed/${videoId}`;
                                                            console.log("EMBED URL:", embedUrl);
                                                            setVideoUrl(embedUrl);
                                                        } else {
                                                            console.log("NOT YOUTUBE → OPENING FILE");
                                                            setVideoUrl(videoSrc);
                                                        }

                                                        setShowVideoModal(true);
                                                    }}
                                                className="bg-blue-900 hover:bg-blue-800 text-white px-6 py-2 rounded-lg font-semibold transition-all"
                                            >
                                                Watch Now
                                            </button>

                                        </div>

                                    </div>
                                );
                            })
                        )}

                    </div>
                )}

                {/* Study Material Section with Preview */}
                {activeTab === 'Study Material' && (
                    <div className="space-y-4 max-h-[600px] overflow-y-auto pr-2">

                        {mediaData.map((v) =>
                            v.attachmentData?.map((att, idx) => {

                                
                                return (
                                    <div
                                        key={`${v.dtlsId}-${idx}`}
                                        className=" w-full
                                        flex
                                        flex-col
                                        md:flex-row
                                        items-start
                                        md:items-center
                                        gap-4
                                        border
                                        rounded-2xl
                                        p-4
                                        bg-white
                                        shadow-sm
                                        hover:shadow-md
                                        transition-all"
                                    >

                                        {/* Left Preview */}
                                        <div className="w-full md:w-44 h-32 bg-blue-50 rounded-xl flex items-center justify-center shrink-0">

                                            <div className="text-center">
                                                <div className="text-5xl mb-2">📘</div>
                                                <p className="font-bold text-blue-900">
                                                    PDF
                                                </p>
                                            </div>

                                        </div>

                                        {/* Right Content */}
                                        <div className="flex-1">

                                            <h3 className="text-lg md:text-xl font-bold text-gray-800 mb-2 break-words">
                                                {att.description ||
                                                    "Study Material"}
                                            </h3>

                                            <p className="text-sm text-gray-500 mb-4">
                                                Open and read the material
                                            </p>

                                            <a
                                                href={`${process.env.REACT_APP_MEDIA_URL || 'https://tgsh.geometricsoft.com'}/${att.attachmentname}`}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="inline-block bg-green-600 hover:bg-green-700 text-white px-6 py-2 rounded-lg font-semibold"
                                            >
                                                Open Material
                                            </a>

                                        </div>

                                    </div>
                                );
                            })
                        )}

                    </div>
                )}
                {activeTab === 'Query' && (
                    <div className=" w-full
                    max-w-full
                    md:max-w-xl
                    mx-auto
                    flex
                    flex-col
                    h-[60vh]
                    md:h-[500px]
                    relative">

                        <h3 className="text-lg md:text-xl font-bold text-blue-900 mb-4 border-b pb-2">
                            Chat with Admin
                        </h3>

                        <div
                        className="
                            flex-1
                            overflow-y-auto
                            overflow-x-hidden
                            p-3
                            
                            bg-slate-50
                            rounded-xl
                            border
                        "
                        >
                            {chatHistory.map((chat, i) => (
                                <div
                                    key={i}
                                    className={`mb-4 flex flex-col ${
                                        chat.UserType === "1"
                                            ? "items-end pr-2"
                                            : "items-start pl-2"
                                    }`}
                                >
                                    <div
                                        className={`
                                            px-4 py-3
                                            rounded-3xl
                                            w-fit
                                            max-w-[75%]
                                            md:max-w-[80%]
                                            break-words
                                            overflow-hidden
                                            ${
                                                chat.UserType === "1"
                                                    ? "bg-blue-900 text-white"
                                                    : "bg-white border"
                                            }
                                        `}
                                    >
                                        <p className="text-sm md:text-base break-words">
                                            {chat.UserQuery || chat.QueryAnswered}
                                        </p>

                                        {chat.file_attachment && (
                                            <a
                                                href={`${process.env.REACT_APP_MEDIA_URL || 'https://tgsh.geometricsoft.com'}/media/${chat.file_attachment}`}
                                                target="_blank"
                                                rel="noreferrer"
                                                className="block
                                                mt-2
                                                text-xs
                                                underline
                                                break-all
                                                max-w-full
                                                overflow-hidden"
                                            >
                                                📄 File
                                            </a>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="mt-auto
                        bg-white
                        border-t
                        p-2
                        shrink-0">

                            {filePreview && (
                                <div
                                    className="
                                        p-2
                                        bg-gray-100
                                        flex
                                        justify-between
                                        items-center
                                        gap-2
                                        text-xs
                                        mb-2
                                        rounded
                                    "
                                >
                                    <span className="break-all flex-1">
                                        {file?.name}
                                    </span>

                                    <button
                                        onClick={() => {
                                            setFile(null);
                                            setFilePreview(null);
                                        }}
                                    >
                                        X
                                    </button>
                                </div>
                            )}

                           
                            <div className="flex items-center bg-white border border-gray-300 rounded-full px-3 h-11 w-full">

                                <label className="cursor-pointer text-gray-500">
                                    <FaPaperclip size={16} />
                                    <input
                                        type="file"
                                        className="hidden"
                                        onChange={handleFileChange}
                                    />
                                </label>

                                <input
                                    value={newMessage}
                                    onChange={(e) => setNewMessage(e.target.value)}
                                    placeholder="Type message..."
                                    className="flex-1 min-w-0 px-3 text-sm bg-transparent outline-none"
                                />

                                <button
                                    onClick={sendMessage}
                                    className="text-blue-900 p-1"
                                >
                                    <FaPaperPlane size={16} />
                                </button>

                            </div>
                        </div>
                    </div>
                )}
                {activeTab === 'Book Appointment' && (
                    <div className="max-w-2xl mx-auto p-4 md:p-6 bg-white rounded-2xl border border-gray-100 shadow-xl">
                        <div className="text-center mb-8">
                            <h3 className="text-2xl font-bold text-blue-900">Book Appointment</h3>
                            <p className="text-gray-500 text-sm mt-1">Please fill the details below, and we will get back to you.</p>
                        </div>

                        <div className="space-y-4 md:grid md:grid-cols-2 md:gap-6 md:space-y-0">
                            {/* Age Field */}
                            <div className="space-y-1">
                                <label className="text-sm font-semibold text-gray-700">Your Age</label>
                                <input 
                                    type="number" 
                                    className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-900 outline-none transition-all"
                                    placeholder="e.g., 30"
                                    value={apptForm.age}
                                    onChange={(e) => setApptForm({...apptForm, age: e.target.value})} 
                                />
                            </div>

                            {/* Occupation Field */}
                            <div className="space-y-1">
                                <label className="text-sm font-semibold text-gray-700">Occupation</label>
                                <input 
                                    type="text" 
                                    className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-900 outline-none transition-all"
                                    placeholder="e.g., Engineer"
                                    value={apptForm.occupation}
                                    onChange={(e) => setApptForm({...apptForm, occupation: e.target.value})} 
                                />
                            </div>
                        </div>

                        {/* Problem Field */}
                        <div className="space-y-1 mt-6">
                            <label className="text-sm font-semibold text-gray-700">Describe your health concern</label>
                            <textarea 
                                className="w-full p-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-900 outline-none transition-all h-32"
                                placeholder="Briefly describe your problem..."
                                value={apptForm.problem}
                                onChange={(e) => setApptForm({...apptForm, problem: e.target.value})} 
                            />
                        </div>

                        {/* Submit Button */}
                        <div className="mt-8">
                            <button 
                                onClick={handleBookAppointment}
                                className="w-full bg-blue-900 text-white font-bold py-3 rounded-xl hover:bg-blue-800 transition-all shadow-lg hover:shadow-blue-200"
                            >
                                Submit Request
                            </button>
                        </div>
                    </div>
                )}
                {activeTab === 'FeedBack' && (
                    <div className="max-w-3xl mx-auto p-4 sm:p-6 md:p-8 bg-white rounded-3xl border border-gray-200 shadow-2xl">
                        <h2 className="text-3xl font-bold text-blue-900 mb-6">Share Your Feedback</h2>
                        
                        <div className="space-y-5">
                            {/* Title */}
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-1">Feedback Title (*)</label>
                                <input className="w-full p-3 border rounded-xl" value={feedbackForm.feedbacktitle} 
                                    onChange={(e) => setFeedbackForm({...feedbackForm, feedbacktitle: e.target.value})} placeholder="Enter Feedback Title" />
                            </div>

                            {/* Description */}
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-1">Feedback (*)</label>
                                <textarea className="w-full p-3 border rounded-xl h-32" value={feedbackForm.feedbackdesc} 
                                    onChange={(e) => setFeedbackForm({...feedbackForm, feedbackdesc: e.target.value})} placeholder="Enter Feedback Description" />
                            </div>

                            {/* Given By */}
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-1">Given By (*)</label>
                                <input className="w-full p-3 border rounded-xl bg-gray-100" value={feedbackForm.givenby} disabled />
                            </div>

                            {/* Profession */}
                            <div>
                                <label className="block text-sm font-bold text-gray-700 mb-1">Profession (*)</label>
                                <input className="w-full p-3 border rounded-xl" value={feedbackForm.profession} 
                                    onChange={(e) => setFeedbackForm({...feedbackForm, profession: e.target.value})} placeholder="Enter Profession" />
                            </div>

                            <button onClick={handleSubmitFeedback} className="w-full bg-blue-900 text-white py-4 rounded-xl font-bold hover:bg-blue-800 transition">
                                Submit
                            </button>
                        </div>
                    </div>
                )}

            </div>

            {/* Video Player Modal */}
            {showVideoModal && (
                <div className="fixed inset-0 bg-black/95 flex items-center justify-center z-[2000]">

                    <button
                        onClick={() => setShowVideoModal(false)}
                        className="absolute top-5 right-10 text-white text-4xl"
                    >
                        &times;
                    </button>

                    {videoUrl?.includes('youtube.com/embed/') ? (
                        <iframe
                            src={videoUrl}
                            className="w-full max-w-5xl h-[80vh]"
                            allowFullScreen
                        />
                    ) : (
                        <video
                            controls
                            autoPlay
                            className="w-full max-w-4xl"
                            src={videoUrl}
                        />
                    )}

                </div>
            )}
        </div>
    );
};

export default MudrabhyasHindi;